const data = [
  {
    Name: "Soumitra Bapat",
    Board: "Assistant",
    Position: "Assistant Secretary",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624876/sait%20images/Soumitra_tbmuew.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/soumitra-bapat-78772125b",
    GitHubProfile: "https://github.com/LR7Garmi",
    InstagramProfile:
      "https://instagram.com/soumitra__9458?utm_source=qr&igshid=MzNlNGNkZWQ4Mg%3D%3D",
  },

  {
    Name: "Rucha Ikare",
    Board: "Assistant",
    Position: "Assistant Secretary",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624856/sait%20images/Rucha_Ikare_j5u9qr.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/rucha-ikare",
    GitHubProfile: "https://github.com/Ruch13",
    InstagramProfile: "https://www.instagram.com/rucha_ikare/",
  },

  {
    Name: "Sharvari Jadhav",
    Board: "Assistant",
    Position: "Assistant Secretary",
    Photo:
      "https://res.cloudinary.com/dptdrzycj/image/upload/v1704356594/Sharvari_Jadhav_-_Sharvari_Jadhav_izrikj.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/jadhav-sharvari09",
    GitHubProfile: "https://github.com/sharvari-09",
    InstagramProfile: null,
  },

  {
    Name: "Parag Patkulkar",
    Board: "Assistant",
    Position: "Assistant Program Director",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624851/sait%20images/Parag_Patkulkar_tynhxe.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/parag-patkulkar-ba00891a8",
    GitHubProfile: "https://github.com/Quanta3",
    InstagramProfile: "https://www.instagram.com/_para.g403",
  },

  {
    Name: "Srushti Karadi",
    Board: "Assistant",
    Position: "Assistant Program Director",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624876/sait%20images/Srushti_Karadi_zsnrwh.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/srushti-karadi-21645b27a",
    GitHubProfile: "https://github.com/srushtikd13",
    InstagramProfile:
      "https://instagram.com/ksrushti_1111?igshid=MzRlODBiNWFlZA==",
  },
  {
    Name: "Manmath  Mungde",
    Board: "Assistant",
    Position: "Assistant Program Director",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624849/sait%20images/Manmath_Mungde_xfze6n.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/manmath-mungde-5b388825b",
    GitHubProfile: "https://github.com/manmath_18",
    InstagramProfile: "https://www.instagram.com/manmath_mungde",
  },
  {
    Name: "Vedant Lonkar",
    Board: "Assistant",
    Position: "Assistant Program Director",
    Photo:
      "https://res.cloudinary.com/dptdrzycj/image/upload/v1704629195/1bdbc0ae-d509-44bf-a461-c9e8135dba03_lawzcm.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/vedant-lonkar-4a37a91b8",
    GitHubProfile: "https://github.com/vedantlonkar23",
    InstagramProfile: "https://www.instagram.com/mevedantlonkar",
  },
  {
    Name: "Aaryash Devane",
    Board: "Assistant",
    Position: "Assistant Program Director",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624823/sait%20images/Aaryash_Devane_atycqf.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/aaryash-devane",
    GitHubProfile: "https://github.com/Aaryashdevane",
    InstagramProfile: "https://www.instagram.com/Cadet_0110",
  },
  {
    Name: "Prapti Gawande",
    Board: "Assistant",
    Position: "Assistant Club Service Director",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624854/sait%20images/Prapti_Gawande_saci3u.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/prapti-gawande-54003b25a",
    GitHubProfile: "https://github.com/praptigawande2812",
    InstagramProfile:
      "https://instagram.com/praptigawande_28?utm_source=qr&igshid=NGExMmI2YTkyZg%3D%3D",
  },

  {
    Name: "Hemant Sharma",
    Board: "Assistant",
    Position: "Assistant Club Service Director",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624845/sait%20images/Hemant_Sharma_dsdhan.jpg",
    LinkedInProfile: "",
    GitHubProfile: "",
    InstagramProfile: "",
  },

  {
    Name: "Shruti Ramteke",
    Board: "Assistant",
    Position: "Assistant Club Service Director",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624873/sait%20images/Shruti_Ramteke_ss7bif.jpg",
    LinkedInProfile: "",
    GitHubProfile: "https://github.com/131shruti",
    InstagramProfile: "",
  },

  {
    Name: "Sandesh Shinde",
    Board: "Assistant",
    Position: "Assistant Club Service Director",
    Photo:
      "https://res.cloudinary.com/dptdrzycj/image/upload/v1704356554/20231231_175933_-_Sandesh_Shinde_bhcg8x.jpg",
    LinkedInProfile: "www.linkedin.com/in/sandesh-shinde-s1730",
    GitHubProfile: "https://github.com/sandeshshinde30",
    InstagramProfile: "https://www.instagram.com/sandesh_shinde_1730/",
  },

  {
    Name: "Shashank Pujari",
    Board: "Assistant",
    Position: "Assistant Club Service Director",
    Photo:
      "https://res.cloudinary.com/dptdrzycj/image/upload/v1704356647/IMG-20230218-WA0019_2_-_22610045_PUJARI_SHASHANK_SHRIDHAR_ggw43j.jpg",
    LinkedInProfile:
      "https://www.linkedin.com/in/shashank-pujari-624190261?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    GitHubProfile: null,
    InstagramProfile:
      "https://www.instagram.com/shashankpujari_18?igsh=djd5YWR2ZXJrbml6",
  },
  {
    Name: "Tanmay Shingde",
    Board: "Assistant",
    Position: "Assistant Web Developer",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624878/sait%20images/Tanmay_Shingde_zdxxrj.png",
    LinkedInProfile: "https://www.linkedin.com/in/tanmay-shingde-6084ab250/",
    GitHubProfile: "https://github.com/tanmay-8",
    InstagramProfile: "https://www.instagram.com/tanmayshingde",
  },
  {
    Name: "Shreyas Kamble",
    Board: "Assistant",
    Position: "Assistant Web Developer",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624863/sait%20images/Shreyas_Kambale_p6vevc.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/shreyas-kamble-aa465922a",
    GitHubProfile: "https://github.com/shreyaskamble1612",
    InstagramProfile: "https://www.instagram.com/shreyas__1612",
  },
  {
    Name: "Vighnesh Potdar",
    Board: "Assistant",
    Position: "Assistant Web Developer",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624881/sait%20images/Vighnesh_Potdar_xzika4.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/vighnesh-potdar-830222254",
    GitHubProfile: "https://github.com/Voodels",
    InstagramProfile: "https://www.instagram.com/vigg1837",
  },
  {
    Name: "Omkar Patange",
    Board: "Assistant",
    Position: "Assistant Web Developer",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624854/sait%20images/Omkar_Patange_m3087q.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/omkar-patange-4179b5184",
    GitHubProfile: "https://github.com/omkar-patange",
    InstagramProfile: "https://www.instagram.com/omkarpatange_",
  },
  {
    Name: "Vidyadhar Dinde",
    Board: "Assistant",
    Position: "Assistant Programming Expert",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624879/sait%20images/Vidyadhar_dhinde_maqujm.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/vidyadhar-dinde-447371252/",
    GitHubProfile: "https://github.com/vidyadhar01",
    InstagramProfile: "https://www.instagram.com/_vidyadhar_d/",
  },
  {
    Name: "Satej Sawant",
    Board: "Assistant",
    Position: "Assistant Programming Expert",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624861/sait%20images/Satej_Sawant_p4jvnv.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/satej-sawant-92a8a4269",
    GitHubProfile: "https://github.com/SatejSawant45",
    InstagramProfile: "https://www.instagram.com/satej.s",
  },

  {
    Name: "Adarsh Sahu",
    Board: "Assistant",
    Position: "Assistant Programming Expert",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624823/sait%20images/Adarsh_Sahu_drf55h.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/adarsh-sahu-8888aa244/",
    GitHubProfile: "https://github.com/AdarshSahu460",
    InstagramProfile: "https://www.instagram.com/theadarshsahu/",
  },
  {
    Name: "Kranti  Varekar",
    Board: "Assistant",
    Position: "Assistant Public Relation Officer",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624849/sait%20images/kranti_varekar_stdltn.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/kranti-varekar-1a7404267",
    GitHubProfile: "https://github.com/krnati",
    InstagramProfile: "",
  },
  {
    Name: "Purva Patil",
    Board: "Assistant",
    Position: "Assistant Public Relation Officer",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624856/sait%20images/Purva_Patil_bnofca.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/purva-patil-a29175270",
    GitHubProfile: "https://github.com/Purva200",
    InstagramProfile:
      "https://instagram.com/purva_patil_2108?utm_source=qr&igshid=MzNlNGNkZWQ4Mg%3D%3D",
  },

  {
    Name: "Divya Tarkase",
    Board: "Assistant",
    Position: "Assistant Public Relation Officer",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624845/sait%20images/Divya_Tarkase_zesjnq.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/divya-tarkase-56ab30265",
    GitHubProfile: "https://github.com/DivyaTarkase",
    InstagramProfile:
      "https://instagram.com/dearly_div?utm_source=qr&igshid=ZDc4ODBmNjlmNQ%3D%3D",
  },

  {
    Name: "Prathamesh Patil",
    Board: "Assistant",
    Position: "Assistant Public Relation Officer",
    Photo:
      "https://res.cloudinary.com/dptdrzycj/image/upload/v1704356513/23620003_-_Prathamesh_Patil_hv20xp.jpg",
    LinkedInProfile:
      "https://www.linkedin.com/in/prathamesh-patil-20b8aa28b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    GitHubProfile: null,
    InstagramProfile: "https://www.instagram.com/07_pratham_patil",
  },
  {
    Name: "Vedant Panari",
    Board: "Assistant",
    Position: "Assistant Aptitude Developer",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624878/sait%20images/Vedant_Panari_h6huyi.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/vedant-panari-379869287",
    GitHubProfile: "https://github.com/VedantPanari",
    InstagramProfile:
      "https://instagram.com/vedantpanari?utm_source=qr&igshid=MzNlNGNkZWQ4Mg%3D%3D",
  },

  {
    Name: "Anuja Suntnur",
    Board: "Assistant",
    Position: "Assistant Aptitude Developer",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624844/sait%20images/Anuja_Suntnur_gdbyof.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/anuja-suntnur-93176225b",
    GitHubProfile: "https://github.com/anuja2004",
    InstagramProfile: "https://www.instagram.com/_anuja_suntnur",
  },
  {
    Name: "Aditya Aparadh",
    Board: "Assistant",
    Position: "Assistant Aptitude Developer",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624824/sait%20images/Aditya_Aparadh_o603b1.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/aditya-aparadh-279638255",
    GitHubProfile: "https://github.com/AdityaAparadh",
    InstagramProfile: "",
  },

  {
    Name: "Ameya Unchagaonkar",
    Board: "Assistant",
    Position: "Assistant Aptitude Developer",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624841/sait%20images/Ameya_Uchagaonkar_kpzvbc.png",
    LinkedInProfile: "https://www.linkedin.com/in/ameya-unchagaonkar-13b99327a",
    GitHubProfile: "https://github.com/aunchagaonkar",
    InstagramProfile: "",
  },

  {
    Name: "Mahemud Borgave",
    Board: "Assistant",
    Position: "Assistant Aptitude Developer",
    Photo:
      "https://res.cloudinary.com/dptdrzycj/image/upload/v1704356686/md_1_-_23620005_BORGAVE_MAHEMUD_USMAN_nnhxht.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/mahemud-borgave-b01762231/",
    GitHubProfile: "https://github.com/mahemudborgave",
    InstagramProfile: "https://www.instagram.com/95_mahemud/",
  },
  {
    Name: "Vaibhav Kondekar",
    Board: "Assistant",
    Position: "Asistant Editor",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624882/sait%20images/Vaibhav_Kondekar_mqvrcc.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/vaibhav-kondekar-671234265",
    GitHubProfile: "https://github.com/vaibhavKondekar",
    InstagramProfile:
      "https://instagram.com/_vaibhav_7897?utm_source=qr&igshid=ZDc4ODBmNjlmNQ%3D%3D",
  },
  {
    Name: "Ishwari Gharge",
    Board: "Assistant",
    Position: "Assistant Art Director",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624846/sait%20images/Ishwari_Gharge_kwsrf3.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/ishwari-gharge-ab5aa0274",
    GitHubProfile: "https://github.com/IshwariGharge",
    InstagramProfile:
      "https://instagram.com/ish_wari__26?utm_source=qr&igshid=MzNlNGNkZWQ4Mg%3D%3D",
  },
  {
    Name: "Aryan Babar",
    Board: "Assistant",
    Position: "Assistant Art Director",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624850/sait%20images/Aryan_Babar_z65lg2.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/aryan-babar-84771a259",
    GitHubProfile: "https://github.com/Aaryalegend",
    InstagramProfile: "https://instagram.com/aryanbabar5796",
  },
  {
    Name: "Shreyash Pawar",
    Board: "Assistant",
    Position: "Assistant Treasurer",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693639889/sait%20images/Shreyash_Pawar_esnozv.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/shreyash-pawar-386486249",
    GitHubProfile: "https://github.com/Ssp63",
    InstagramProfile:
      "https://instagram.com/s.s.p_63?utm_source=qr&igshid=MzNlNGNkZWQ4Mg%3D%3D",
  },
  {
    Name: "Atharva Khot",
    Board: "Assistant",
    Position: "Assistant Treasurer",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624840/sait%20images/Atharva_Khot_brdsdz.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/atharva-khot-3b2479257",
    GitHubProfile: "https://github.com/AtharvaKhot17",
    InstagramProfile:
      "https://instagram.com/_atharva017?utm_source=qr&igshid=MzNlNGNkZWQ4Mg%3D%3D",
  },
];

export default data;
